import React from 'react'
import { FaEnvelope,FaMapMarkerAlt,FaMobileAlt } from "react-icons/fa";
import './Contact.scss';
import { Col, Row } from 'react-bootstrap';
const Contact = () => {
  return (
    <div>
    <div className="contact-title">
        <h1>Consulta abogado</h1>
    </div>
    <Row>
            <Col md={4}>
                <div className='contact-items'>    
                    <a
                        href="mailto:macarenapereiraabogada@gmail.com?subject=Consulta%20Legal&body=Hola%2C%20necesito%20ayuda%20con..." 
                    >
                        <FaEnvelope className="icon"/><p>macarenapereiraabogada@gmail.com</p>
                    </a>
                </div> 
            </Col>
            
            <Col md={4}>
                <div className='contact-items'>
                    <a 
                        href="https://www.google.com/maps?q=Villota+%23138,+Oficina+2,+Curic%C3%B3" 
                        target="_blank" 
                        rel="noopener noreferrer"
                    >
                        
                            <FaMapMarkerAlt className="icon"/>
                            <p>Villota #138, Oficina 2, Curicó.</p>
                    </a>
                </div>
            </Col>
            
            <Col md={4}>
                <div className='contact-items'> 
                    <a
                        href='tel:+56973985781'
                    >
                    <FaMobileAlt className="icon"/><p>+56 9 7398 5781</p>
                    </a>
                </div>
            </Col>
            
    </Row>
    </div>
  )
}

export default Contact